import {FilterDef, FilterOperator, FilterType} from "../../components/ExTable";

export function getDateFilterDefinitions<T>(fieldNames: (keyof T)[]): FilterDef<T>[] {
    return fieldNames.map((fieldName) => {
        return {
            fieldName,
            filterOperators: [FilterOperator.LT, FilterOperator.GT, FilterOperator.LTE, FilterOperator.GTE],
            type: FilterType.DATE,
        };
    });
}
